import { EDealType, EOfferType } from 'shared/types/wantType';
import * as styles from './styles.css';
import { TDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';

interface IEffectPlaceCianProps {
  dealType: EDealType;
  offerType: EOfferType;
  device: TDeviceType;
}

export const EffectPlaceCian: React.FC<IEffectPlaceCianProps> = ({ device, dealType, offerType }) => {
  return (
    <div className={clsx(styles['container'], styles[device], styles[dealType], styles[offerType])}>
      <div className={styles['wrapper']}>
        <div className={styles['textblock']}>
          <div className={styles['title']}>Как эффективно размещаться на&nbsp;Циан</div>
          <div className={styles['description']}>
            {dealType === EDealType.Host
              ? 'Расскажем, как сделать привлекательное объявление и стабильно получать брони'
              : 'Мы расскажем, как сделать привлекательное объявление и найти реального покупателя'}
          </div>
        </div>
        <div className={styles['image']} />
      </div>
    </div>
  );
};
